export const BILLING_PLAN_REFRESH_EVENT = "billing:plan-refresh";

export const dispatchBillingPlanRefresh = () => {
  if (typeof window === "undefined") {
    return;
  }

  window.dispatchEvent(new CustomEvent(BILLING_PLAN_REFRESH_EVENT));
};
